import { BaseService } from '../../infra/base.service'
import type { Gateway } from './gateway.entity'
import type { GatewaysRepository } from './gateways.repository'

export class GatewaysService extends BaseService<Gateway> {
    constructor(private rep: GatewaysRepository) {
        super(rep)
    }
    async getOnePublic(gatewayId: string) {
        return await this.rep.getOnePublic(gatewayId)
    }
}
